/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/digital-menus';

export const DigitalMenuApi = {
  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneDetail: async id => {
    const url = `${pathname}/admin/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: FilterDigitalMenuOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneRetailDigitalMenuForDetail: async (id: string) => {
    const url = `${pathname}/find-one-retail-digital-menu-for-detail/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicateShortID: async (id: string, shortID: string) => {
    let url = `${pathname}/${id}/check-duplicate-short-id`;
    const query = serialize({ shortID });
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FilterDigitalMenuOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  bankID?: string;
  entityID?: string;
  status?: number;
}
